<template>
    <div class="aprh__authentication__login">
        <component
            :is="input"
            class="aprh__authentication__form__field"
            :settings="{
                label: { class: 'field__label__login capitalize', text: $t('global.email') },
                input: {
                    component: 'InputBasic',
                    id: 'email',
                    name: 'email',
                    type: 'text',
                    class: 'aprh__authentication__form__field__input',
                    value: '',
                    placeholder: $t('global.email'),
                    browserAutocomplete: 'email',
                    isRequired: true,
                    fileValidation: 'basicEmail',
                    errors: [{
                        type: 'email', warning: $t('error.email')
                    }],
                    isMissing: errors.missing.email,
                    noListener: true
                },
                allowFilling: true
            }"
        />
        <base-password
            :input="input"
            class="aprh__authentication__form__field"
            :settings="{
                label: { class: 'capitalize field__label__login', text: $t('global.password') },
                input: {
                    name: 'password',
                    class: 'aprh__authentication__form__field__input',
                    placeholder: $t('global.password'),
                    fileValidation: null,
                    browserAutocomplete: 'current-password',
                    isMissing: errors.missing.password,
                    noListener: true
                }
            }"
        />
    </div>
</template>

<script>
// store
// eslint-disable-next-line
import { mapState } from '@/hooks/use-store';

export default {
    components: {
        BasePassword: () => import( /* webpackChunkName: 'BasePassword' */ '@/components/bundles/fields/BasePassword' )
    },
    props: {
        input: Function
    },
    setup () {
        const errors = mapState({ module: 'storePayload', key: 'errors' });

        return { errors };
    }
};
</script>